import { ArrowRight } from 'lucide-react'
import { Button } from '@/src/renderer/components/ui/Button'
import happyCloudImg from './assets/happycloud-sync.png'
import './HappyCloudEntryCard.scss'

interface HappyCloudEntryCardProps {
  /** Brand title — almost always "HappyCloud". */
  title: string
  /** Optional supporting line shown under the title (Profil page). */
  subtitle?: string
  /** Optional inline "more info" link next to the title (Welcome screen). */
  moreInfo?: { label: string; onClick: () => void }
  /** Primary CTA on the right. `trailingArrow` adds a → after the label. */
  action: { label: string; onClick: () => void; trailingArrow?: boolean }
  /** Fully-rounded pill shape (WelcomeScreen strip). Default is a rounded
   *  rectangle (Profil page). */
  pill?: boolean
}

/**
 * HappyCloud promo card — cloud illustration + brand title on the left, a CTA
 * button on the right. Reused in two places (modeled on the Figma "Entry" /
 * "Onboarding 2" components):
 * - "Profil" settings page: title + subtitle + "Einrichten →"
 * - WelcomeScreen strip: title + inline "Mehr erfahren" link + "Registrieren
 *   oder Anmelden"
 */
export function HappyCloudEntryCard({ title, subtitle, moreInfo, action, pill }: HappyCloudEntryCardProps) {
  return (
    <div className={`happycloud-entry${pill ? ' happycloud-entry--pill' : ''}`}>
      <img src={happyCloudImg} alt="" className="happycloud-entry__cloud" />
      <div className="happycloud-entry__text">
        <div className="happycloud-entry__title-row">
          <p className="happycloud-entry__title">{title}</p>
          {moreInfo && (
            <button type="button" className="happycloud-entry__more" onClick={moreInfo.onClick}>
              {moreInfo.label}
            </button>
          )}
        </div>
        {subtitle && <p className="happycloud-entry__subtitle">{subtitle}</p>}
      </div>
      <Button variant="outline" onClick={action.onClick}>
        <span className="happycloud-entry__cta">
          {action.label}
          {action.trailingArrow && <ArrowRight size={16} aria-hidden="true" />}
        </span>
      </Button>
    </div>
  )
}
